import React from 'react'
import CurrencyInput from 'components/CurrencyInput'

import {
  numberWithCommas,
  numberClearCommas,
  presenceErrorClass,
  numberAddCommas,
  isNumericOnly,
} from 'servos/formValidations'

import { getLoanRatio } from 'servos/loanApplication'

class LoanAmount extends React.Component {
  state = {
    loanAmount: numberClearCommas(this.props.loanAmount) || null,
    spendAmount: this.props.spendAmount || null,
    rentAmount: this.props.rentAmount || null,
    displayErrors: false
  }

  // This is ugly but for now MUST stay.
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState) {
      return true
    } else if (nextProps.needsRentAmount !== this.props.needsRentAmount) {
      return true
    } else {
      return false
    }
  }

  componentDidUpdate() {
    let {
      loanAmount,
      spendAmount,
      rentAmount,
    } = this.state;
    let {
      onChange
    } = this.props;

    if (onChange) {
      onChange({
        loanAmount,
        spendAmount,
        rentAmount,
        loanRatio: getLoanRatio(loanAmount, spendAmount),
        loanAmountValid: this.loanAmountValid(),
      })
    }
  }

  onChange(params) {
    this.setState({
      ...params,
      displayErrors: true,
    })
  }

  loanAmountValid() {
    return(
      this.loanRatioValid() &&
      this.loanMinValid() &&
      this.loanMaxValid() &&
      this.spendAmountValid() &&
      this.rentAmountValid()
    )
  }

  loanRatioValid() {
    const maxRatio = I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.validation.ratio')
    const { loanAmount, spendAmount } = this.state

    if ( loanAmount && spendAmount && spendAmount > 0 ) {
      return getLoanRatio(loanAmount, spendAmount) <= maxRatio
    } else {
      return true
    }
  }

  loanMinValid() {
    const minAmount = I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.validation.minimum')
    return ( this.state.loanAmount >= minAmount )
  }

  loanMaxValid() {
    const maxAmount = I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.validation.maximum')
    return ( this.state.loanAmount <= maxAmount )
  }

  spendAmountValid() {
    let { spendAmount } = this.state
    return isNumericOnly(spendAmount)
  }

  rentAmountValid() {
    let { rentAmount } = this.state
    return (this.props.needsRentAmount) ? isNumericOnly(rentAmount) : true
  }

  rentAmountError() {
    let { rentAmount, displayErrors } = this.state

    if (!displayErrors || rentAmount == null) {
      return null
    }

    if (!this.rentAmountValid()) {
      return I18n.t('onboarding.loan_location.errors.not_a_number')
    }
  }

  loanAmountError() {
    let { loanAmount, displayErrors } = this.state

    if (!displayErrors || loanAmount == null) {
      return null
    }

    if (!this.loanMinValid()) {
      return I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.errors.minimum')
    }
    if (!this.loanMaxValid()) {
      return (
        <div onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }>
          <div
            dangerouslySetInnerHTML={ { __html: I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.errors.maximum_html') } }
          />
        </div>
      )
    }
    if (!this.loanRatioValid()) {
      return I18n.t('onboarding.loan_location.loan_amount.'+ this.props.target +'.errors.ratio')
    }
  }

  spendAmountError() {
    let { spendAmount, displayErrors } = this.state

    if (!displayErrors || spendAmount == null) {
      return null
    }

    return this.spendAmountValid() ? null : I18n.t('onboarding.loan_location.errors.not_a_number')
  }

  buildHelpText = () => {
    let { spendAmount } = this.state
    if (spendAmount) {
      return  '80% = $' + numberAddCommas((spendAmount * 0.8).toFixed(0))
    }
    return null
  }

  render() {
    const {
      loanAmount,
      spendAmount,
      rentAmount,
    } = this.state

    const {
      needsRentAmount,
      finalApplication,
    } = this.props

    return (
      <div>
        <div className='form-group form-group-lg'>
          { finalApplication ?
            <label>How much do you think your home is worth?</label> :
            <label>How much are you looking to spend?</label>
          }
          <CurrencyInput
            size='large'
            append='helptext'
            onChange={ (value) => this.onChange({ spendAmount: value  || '' }) }
            defaultValue={ numberAddCommas(spendAmount) }
            placeholder="Enter amount"
            errorMessage={ this.spendAmountError() }
          >
            <div className='input-group-append'>
              <span className={`input-group-text ${ presenceErrorClass(this.spendAmountError()) }`}>
                { this.buildHelpText() }
              </span>
            </div>
          </CurrencyInput>
        </div>

        <div className='form-group form-group-lg'>
          <label>How much would you like to borrow?</label>
          <CurrencyInput
            size='large'
            onChange={ (value) => this.onChange({ loanAmount: value || '' }) }
            defaultValue={ numberAddCommas(loanAmount) }
            placeholder="Enter loan amount"
            errorMessage={ this.loanAmountError() }
          />
        </div>
        {
          (needsRentAmount) &&
          <div className='form-group form-group-lg'>
            <label>How much rent do you think you can get for the home?</label>
            <CurrencyInput
              size='large'
              append='helptext'
              onChange={ (value) => this.onChange({ rentAmount: value || '' }) }
              defaultValue={ numberAddCommas(rentAmount) }
              placeholder="Enter rent amount"
              errorMessage={ this.rentAmountError() }
            >
              <div className='input-group-append'>
                <span className={`input-group-text ${ presenceErrorClass( this.rentAmountError() )}`}>
                  Weekly
                </span>
              </div>
            </CurrencyInput>
          </div>
        }
      </div>
    )
  }
}

export default LoanAmount
